
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topcamplejeunelawyers/privacy-policy",
      function () {
        return require("private-next-pages/topcamplejeunelawyers/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topcamplejeunelawyers/privacy-policy"])
      });
    }
  